import * as types from '../actionsTypes/loadingOverlayActionTypes';


export const showLoadingOverlay = () =>
  ({ type: types.SHOW_LOADING_OVERLAY, payload : {isActive : true} });


export const hideLoadingOverlay = () =>
  ({ type: types.HIDE_LOADING_OVERLAY, payload : {isActive : false} });
